import { Table } from "antd";
import Column from "antd/lib/table/Column";
import React from "react";

import MomentItem from "../../../../components/MomentItem";
import Spinner from "../../../../components/Spinner";
import intl from "../../../../utils/intl";
import messages from "../../messages";
import { Pricing } from "../../Pricing";
import PricingTableProps from "./props";

const supplierIdSorter = (a: Pricing, b: Pricing): number =>
  a.supplierId.localeCompare(b.supplierId);

const partnerIdSorter = (a: Pricing, b: Pricing): number =>
  a.partnerId.localeCompare(b.partnerId);

const PricingTable: React.FC<PricingTableProps> = (
  props: PricingTableProps
) => {
  const paginationOptions = {
    total: props.pricingItems.length,
    showTotal: (total: number, range: [number, number]): React.ReactNode =>
      `${range[0]}-${range[1]} of ${total}`,
  };

  if (props.loading) return <Spinner />;

  return (
    <Table
      dataSource={props.pricingItems}
      scroll={{ x: "max-content" }}
      rowKey={"id"}
      pagination={paginationOptions}
      rowClassName={(record) => (record.isDeleted ? "table-row-delete" : "")}
    >
      <Column
        title={intl.formatMessage(messages.pricingHeaderSupplierId)}
        sorter={supplierIdSorter}
        render={(record: Pricing): React.ReactNode => record.supplierId}
      />
      <Column
        title={intl.formatMessage(messages.pricingHeaderPartnerId)}
        sorter={partnerIdSorter}
        render={(record: Pricing): React.ReactNode => record.partnerId}
      />
      <Column
        title={intl.formatMessage(messages.pricingHeaderType)}
        render={(record: Pricing): React.ReactNode => record.type}
      />
      <Column
        title={intl.formatMessage(messages.pricingHeaderValue)}
        render={(record: Pricing): React.ReactNode => record.value}
      />
      <Column
        title={intl.formatMessage(messages.pricingHeaderFromDate)}
        render={(record: Pricing): React.ReactNode => (
          <MomentItem value={record.fromDate} format="YYYY-MM-DD" />
        )}
      />
      <Column
        title={intl.formatMessage(messages.pricingHeaderToDate)}
        render={(record: Pricing): React.ReactNode => (
          <MomentItem value={record.toDate} format="YYYY-MM-DD" />
        )}
      />
    </Table>
  );
};

export default PricingTable;
